import React, { useState, useImperativeHandle } from 'react';
import './../../styles/Inputs.css';

function TextArea({ label, defaultValue, gridWidth, icon , onChange , visible } , ref ) {
    const startValue = defaultValue ?? '';
    const [ value, setValue ] = useState( startValue );
    
    useImperativeHandle(ref, () => ({
        getValue: () => value,
        setValue: ( newVal ) => setValue(newVal),
    }));

    const handleChange = ( e ) => {
        setValue( e.target.value );
        if ( typeof onChange === 'function' ) {
            onChange( e.target.value );
        }
    };

    const containerClass = [
        'textfield',
        gridWidth === 'HALF' ? 'half' : 'full',
        visible === false ? 'hidden' : ''
    ].join(' ').trim();
    
    return (
        <div className={containerClass}>
            {label != null && (
                <label className="textfield-label">
                    {icon != null && (
                        <span className="textfield-icon">
                            <div dangerouslySetInnerHTML={{ __html: icon }} />
                        </span>
                    )}
                    {label}
                </label>
            )}

            <textarea
                className="textarea-input"
                value={value}
                onChange={ handleChange }
                rows={4}
            />
        </div>
    );
}

export default React.forwardRef(TextArea);